import { getAgentExperience } from './agent/getAgentExperience';
import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isDealRentCianAgency } from './isDealRentCianAgency';

export const agentInfo: TComputedPropMapper<string | undefined> = (props, ctx) => {
  const { isByHomeowner, isTop3, user } = props.offer;
  if (isDealRentCianAgency(props, ctx) || isByHomeowner) {
    return undefined;
  }

  const experience = getAgentExperience(props, ctx);

  if (isTop3 && experience) {
    return experience;
  }

  if (user?.subAgentCompanyName && !user.masterAgent) {
    return user.subAgentCompanyName;
  }

  return undefined;
};
